import React from 'react';
import styled from 'styled-components';

import { Typography, Grid } from '@material-ui/core';

import IconExampleCustomer from '../../assets/icon-example-customer.svg';
import PagePortfolio from '../../pages/PagePortfolio';
import CardWrapper from '../common/CardWrapper';

const Root = styled.div`
	color: ${(props) => props.theme.palette.text.primary};

	.banner {
		display: flex;
		align-items: center;

		.banner__icon {
			flex: 0;
			padding: 20px 40px 20px 20px;

			img {
				width: 80px;
			}
		}

		.banner__content {
			flex: 1;

			h2 {
				margin-bottom: 10px;
				font-size: 24px;
				font-weight: bold;
				text-transform: uppercase;
			}
		}
	}
`;

const EinsparPotentialBeispielKundeCard = () => (
	<Root>
		<CardWrapper>
			<Grid container className="banner">
				<Grid item className="banner__icon">
					<img
						src={IconExampleCustomer}
						alt="Einsparpotential eines Beispielkunden"
					/>
				</Grid>
				<Grid item className="banner__content">
					<Typography variant="h2">
						Einsparpotential eines Beispielkunden entdecken
					</Typography>
					<Typography>
						Der Lastgang eines Beispielkunden zeigt Ihnen den gesamten
						Funktionsumfang unseres KI-basierten Analysetools metis.plus.
					</Typography>
				</Grid>
			</Grid>
			<PagePortfolio comingFromStartseitePage />
		</CardWrapper>
	</Root>
);

export default EinsparPotentialBeispielKundeCard;
